<template>
  <div class="own">
    <div class="user_info">
      <div class="avatar">
        <img :src="userData.headUrl" alt="">
      </div>
      <div class="name">
        <span>{{userData.nickName}}</span>
      </div>
      <div class="info_bar">
        <!-- <div class="info_item">
          <div class="div">{{userData.dayEstimate}}</div>
          <div>今日预估</div>
        </div> -->
        <div class="info_item">
          <div class="div">{{userData.dayEstimate | toFixed2	}}</div>
          <div>今日预估</div>
        </div>
        <div class="info_item">
          <div class="div">{{userData.monthEstimate | toFixed2		}}</div>
          <div>本月预估</div>
        </div>

        <div class="info_item">
          <div class="div">{{userData.lastMonthEstimate | toFixed2		}}</div> 
          <div>上月预估</div>
        </div>
      </div>
      <div class="card">
        <div class="text">账户可用余额   
          <span>{{userData.balance | toFixed2	}}</span>
        </div>
        <div class="btn" @click="toDetail('/withdraw')">提现</div>
      </div>
    </div>

<!-- 我的订单 -->
    <div class="my_order">
      <!-- <div class="title">
        <span class="bold">我的订单</span>

      </div> -->
      <div class="content">
        <div class="content_item" @click="toDetail('/orderDetail?status=0')">
          <img src="@/assets/个人中心/order.png" alt="">
          <div>订单</div>
        </div>
        <div class="content_item" @click="toDetail('/incomeStatement')">
          <img src="@/assets/个人中心/income.png" alt="">
          <div>收益</div> 
        </div>
        <div class="content_item" @click="toDetail('/withdraw')">
          <img src="@/assets/个人中心/withdraw.png" alt="">
          <div>提现</div>
        </div>
        <div class="content_item" @click="toDetail('/invite')">
          <img src="@/assets/个人中心/share.png" alt="">
          <div>邀请</div>
        </div>      
      </div>
    </div>
    <div class="banner" @click="toDetail('/invite')">
      <img src="https://invitecode.oss-cn-shenzhen.aliyuncs.com/yaoqinghaoyou.png" alt="">
    </div>
<!-- 我的服务 -->
    <div class="my_order">
      <!-- <div class="title">
        <span class="bold">我的服务</span>
      </div> -->
      <div class="serve">
        <div class="content_item" @click="toDetail('/authorize')">
        <div>
          <img src="@/assets/个人中心/question.png" alt="">
          <div>常见问题</div>
        </div>
        <van-icon name="arrow" />
        </div>
        <div class="content_item" @click="toDetail('/fans')">
        <div>
          <img src="@/assets/个人中心/team.png" alt="">
          <div>团队</div>
        </div>
        <van-icon name="arrow" />
        </div>
        <div class="content_item" @click="toDetail('/other')" style="border:0;"> 
          <div>
            <img src="@/assets/个人中心/wechar.png" alt="">
            <div>客服</div>
          </div>
          <van-icon name="arrow" />
        </div>  
      </div>
    </div>
    <Nav></Nav>
  </div>
</template> 

<script>
import Nav from "@/components/Nav/index";
import Header from "@/components/Header/index";
import { wxOAuthGetUserVo } from "@/api/user";
import { orderPagerList } from "@/api/ownCenter";
export default {
  name:'Mine',
  components:{
    Header,Nav
  },
  computed:{
    userData(){
      return this.$store.state.userData
    }
  },
  activated(){
    if(this.$store.state.userId == ''){
      return
    }
    this.$store.dispatch('asyncUpdateUserInfo',{userId:this.$store.state.userId}); 
  },
  methods:{
    toDetail(path){
      this.$router.push(path)
    }

    
  }
}
</script>

<style lang="less">
/* zoom */
.zoom-enter-active{
  opacity: 1;
  transition: all .2s ease;  
}
.zoom-enter
 {
  transform: scale(0.85,0.85);
}
// right
.Right-enter-active{
  opacity: 1;
  transition: all .4s ease;  
}
.Right-enter
 {
  transform: translateX(100%);
}
// left
.Left-enter-active{
  opacity: 1;
  transition: all .4s ease;  
}
.Left-enter
 {
  transform: translateX(-100%);
}
.own{
  
  .center{
    text-align: center;
  }
  .user_info{
    width: 100vw;
    height:15.5rem;
    background-image: url('../../assets/个人中心/bg.png');
    object-fit: fill;
    // margin-top: -1px;
    display: flex;
    position: relative;
    margin-bottom: 3.6rem;
    padding-top: 4.8rem;
    .btn{
      font-size: 1.2rem;
      width: 3.5rem;
      text-align: center;
      border: 1px rgba(180, 180, 180, 0.6) solid;
      padding: 0.3rem .5rem;
      border-radius: 5rem;
    } 
    .card{

      box-sizing: border-box;
      position: absolute;
      background-color: #fff;
      width: 95vw;
      left: 2.5vw;
      display: flex;
      justify-content: space-between;
      height: 5.5rem;
      border-radius: 10px;
      align-items: center;
      top: 17rem;
      font-size: 1.4rem;
      padding: 16px 20px;
      .text{
        
        span{
          font-weight: 600;
          font-size: 1.6rem;
          margin-left: .4rem;
          &::before{
            content: '￥';
            font-size: 1.2rem;
            
          }
        }
        &::after{
          content: '每月25号到账，上月所有确认收获订单佣金';
          // position: absolute;
          display: block;
          color: rgba(40, 40,40, 0.6);
          font-size: 1rem;
          margin-top: 5px;
          
        }
      }
    }
    .avatar{
      width: 5rem;
      height: 5rem;
      border-radius: 50%;
      background-color: #fff;
      margin-left: 1.8rem;
      
      img{
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }

    }
    .name{
      
      color: white;
      font-size: 1.8rem;
      margin-left: 1.2rem;
      font-weight: 600;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      // align-items: center;
      width: 8rem;
      height: 4.5rem;
      margin-top: 0.8rem;
      // position: relative;
      div{
        font-size: 1rem;
        color: rgba(250, 250, 250, 1);
        font-weight: normal;

      }
      span{
        white-space: nowrap;
        height: 3rem;
        display: flex;
        align-items: center;
        &::after{
          content: 'VIP会员';
          // display: inline;
          font-size: 1rem;
          margin-left: 1.2rem;
         
          padding:0 1px;
          background-color: rgb(40,40,40);
          text-align: center;
          line-height: 1.6rem;
          border-radius: 10px;
          box-sizing: border-box;
          font-weight: normal;
          border: 1px rgb(80, 80, 80) solid;
           margin-bottom: 6px;
        }
      }



    }
  }
  .info_bar{
    width: 95vw;
    height: 6rem;
    margin-left: 2.5vw;
    border-radius: 10px;
    display: flex;
    justify-content: space-around;
    text-align: center;
    align-items: center;
    position:absolute;
    top: 10.4rem;
    color: white;
    // background-color: #fff;
    .info_item{
      font-size: 1.2rem;
      .div{
        font-weight: 600;
        font-size: 1.6rem;
        margin-bottom: 0.8rem;
        text-align: center;
          &::before{
            content: '￥';
            font-size: 1.2rem;
            
          }                
      }
    }

  }

.my_order{
  background-color: #fff;
  width: 95vw;
  margin-left: 2.5vw;
  // margin: 1rem 2.5vw;
  margin-top: 2rem;
  
  border-radius: 8px;
  box-sizing: border-box;
  .title{
    font-size: 1.25rem;
    font-family: PingFangSC-Regular;
    margin: 0.5rem 1rem;
    height: 4rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: solid 1px rgba(130, 130, 130, 0.1);
    color: rgba(100, 100, 100, 0.8);
    .bold{
      // font-weight: 600;
      font-size: 1.6rem;
      letter-spacing: 0;
      color: rgb(10, 10, 10);
    }
  }
  .content{
    display: flex;
    justify-content: space-around;
    align-items: center;
    text-align: center;
    margin: .5rem 0;
    height: 7rem;
    font-size: 1.2rem;
    img{
      width: 3rem;
      height: 3rem;
      margin-bottom: 2px;
    }
  }
  .serve{
    display: flex;
    justify-content: space-around;
    flex-direction: column;
  
    padding: .5rem 1rem;
    margin: .5rem 0;
    margin-bottom: 5.8rem;
    height: 17rem;
    font-size: 1.4rem;
    img{
      width: 2.8rem;
      height: 2.8rem;
      margin-bottom: .2rem;
      margin-right: 1.4rem;
    }   
    .content_item{
      div{
        display: flex;
        align-items: center;
      }
      i{
        opacity: .6;
      }
      padding: .5rem 1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: solid 1px rgba(130, 130, 130, 0.1);
    }
  }
}
}
.banner{
  width: 95vw;
  
  border-radius: 6px;
  margin: 2rem 0;
  margin-left: 2.5vw;
  img{
    width: 100%;
    border-radius: 6px;
  }
}
</style>